import React, {useMemo, useState} from "react";

import {useTranslation} from "react-i18next";
import PlanItem from "./PlanItem";
import InfiniteList from "shared/ui/list/InfiniteList";
import {queries} from "shared/api/queries";
import {useDebounce} from "shared/hooks/useDebounce";
import {Button, Input} from "shared/ui";
import {IPlanLongItem, IPlanShortItem, MapSearchParamKey, PlanSearchParamKey} from "features/plan/types";
import {useSearchParams} from "react-router-dom";
import "./planModal.css"
import {formatDate} from "../../../../shared/lib/fns";

interface Props {
  onSelectPlan: (plan: IPlanShortItem) => void;
  selectedPlan?: IPlanShortItem;
  srcPlan?: IPlanLongItem;
}

export const PlanList = ({onSelectPlan, selectedPlan, srcPlan}: Props) => {
  const {t} = useTranslation("shipping");
  const [inputValue, setInputValue] = useState("");
  const [params] = useSearchParams()
  const planDate = params.get(PlanSearchParamKey.planDate);
  const planNo = params.get(PlanSearchParamKey.planNo);
  
  const listParams = useMemo(() => {
    const nextParams = new URLSearchParams();
    nextParams.delete(MapSearchParamKey.mapCenterLat);
    nextParams.delete(MapSearchParamKey.mapCenterLng);
    nextParams.delete(MapSearchParamKey.mapZoom);
    nextParams.set(PlanSearchParamKey.planDate, planDate ?? formatDate(new Date()))
    if (planNo) nextParams.set(PlanSearchParamKey.planNo, planNo)
    if (inputValue) {
      nextParams.set(PlanSearchParamKey.clusterIdStartswith, inputValue);
    }
    else {
      nextParams.delete(PlanSearchParamKey.clusterIdStartswith);
    }
    
    return nextParams.toString();
  }, [inputValue, planDate]);
  
  const debouncedChange = useDebounce((value: string) => {
    setInputValue(value);
  }, 1000);
  
  const handleSearch = (e: any) => {
    debouncedChange(e.target.value);
  };
  
  return (<>
    <Input
      onChange={handleSearch}
      size={"sm"}
      className={"plan-input"}
      placeholder={t("search plan")}
      icon={<Button size={"sm"} className={"px-0 pr-2"} variant={"text"} onClick={handleSearch}>
        {t("Search")}
      </Button>}
      autoComplete={"off"}
    />
    <InfiniteList<IPlanShortItem>
      url={queries.plan.short}
      params={listParams}
      height={300}
      itemSize={46}
      shouldRender={(plan) => !!srcPlan ? plan.id !== srcPlan.id : true}
      renderItem={(plan, style) => (<PlanItem
        key={"rider" + plan.id}
        selected={plan.id === selectedPlan?.id}
        plan={plan}
        style={style}
        onSelect={onSelectPlan}
      />)} />
  </>);
};
